var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-app", { attrs: { id: "app" } }, [
    _c(
      "div",
      [
        _c("navigation-menu", {
          staticClass: "navigation-menu",
          attrs: { color: "111111" },
        }),
        _vm._v(" "),
        _c(
          "div",
          { ref: "appContent", staticClass: "appcontent" },
          [
            _c("widget-cards-buffer"),
            _vm._v(" "),
            !_vm.$store.getters.isAuthenticated
              ? _c("div", [
                  _c("div", { staticClass: "container h-100 pt-5" }, [
                    _c(
                      "div",
                      {
                        staticClass:
                          "row h-100 justify-content-center align-items-center",
                      },
                      [
                        _c("div", { staticClass: "col-8" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "border border-secondary p-3 text-center",
                            },
                            [
                              _c("h1", { staticClass: "display-4" }, [
                                _vm._v(_vm._s(_vm.$t("app.lbl_title"))),
                              ]),
                              _vm._v(" "),
                              _c("div", [
                                _c("span", {
                                  staticClass: "mdi mdi-loading mdi-spin",
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v(_vm._s(_vm.$t("app.lbl_text"))),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-2" }, [
                                  _vm.$store.getters.isBackLogin
                                    ? _c("span", {
                                        staticClass: "mdi mdi-loading mdi-spin",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.$store.getters.isBackLogin
                                    ? _c("span", {
                                        staticClass: "mdi mdi-signal",
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.$t("app.lbl_back_login"))
                                    ),
                                  ]),
                                ]),
                                _vm._v(" "),
                                _vm.$store.getters.isLoginError
                                  ? _c("div", { staticClass: "text-primary" }, [
                                      _c("span", {
                                        staticClass:
                                          "mdi mdi-alert-circle-outline",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(_vm.$t("app.lbl_error_login"))
                                        ),
                                      ]),
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _c("div", { staticClass: "mt-1" }, [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-outline-primary",
                                      on: {
                                        click: function ($event) {
                                          return _vm.fnLogout()
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n                                            LogOut & Clean\n                                        "
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ])
              : _c(
                  "div",
                  { staticClass: "page" },
                  [
                    _c(
                      "transition",
                      { attrs: { name: "slide", mode: "out-in" } },
                      [
                        _c("router-view", {
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function ({ Component }) {
                                return [_c(Component, { tag: "component" })]
                              },
                            },
                          ]),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }